import React from 'react';
import Slider from 'react-slick';
import Settings from './SlickSettings';
import { Insights } from './data';

const settings = {
  ...Settings,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const TravelInsights = () => (
  <div className="horizontal-scroll-content" id="horizontal-scroll-content-2">
    <div className="container mb-1 py-4">
      <div className="row">
        <div className="col-12">
          <h2 className="text-uppercase text-center section-header">
            STEP 1: PLAN YOUR TOUR WITH EXPERT GUIDANCE
          </h2>
          <p className="font-weight-normal text-center">
            HoneyGuide has the most detailed information and most straightforward answers.
          </p>
          <hr className="hr--small mb-4" />
          <style
          dangerouslySetInnerHTML={{
            __html:
              '\n.block-background--1 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/everest-villages.jpg);\n}\n.block-background--2 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/namche-profile.jpg);\n}\n.block-background--3 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/home-guide.jpg);\n}\n.block-background--4 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/lodge-profile.jpg);\n}\n.block-background--5 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/ecb-trek-in.jpg);\n}\n.block-background--6 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/everest-everything.jpg);\n}\n.block-background--7 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/time-to-everest.jpg);\n}\n.block-background--8 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/health-safty.jpg);\n}\n.block-background--9 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/lukla-flight-guide.jpg);\n}\n.block-background--10 {\nbackground: url(https://s3.amazonaws.com/honeyguide/assets/ebc-trek-dec.jpg);\n}\n',
          }}
          />
          <div className="block-grid d-none d-md-block">
            {Insights.map((insight, idx) => (
              <a
                href={insight.link}
                className="block"
                data-toggle="modal"
                data-target=".insights-modal"
                key={insight.name}
              >
                <div className={`block-background block-background--${idx + 1}`} />
                <div className="block-content">
                  <div>
                    <strong>{insight.name}</strong>
                  </div>
                  <div>
                    <i className={insight.icon}>
                      <svg viewBox="0 2 32 32" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M31.38 16.592a6.068 6.068 0 0 0-1.254-1.704s-4.094-5.21-5.404-6.991c-1.197-1.63-3.242-2.422-5.093-1.517-1.85.905-2.655 3.064-1.928 4.95l.577 2.244h-4.556l.576-2.244c.728-1.886-.077-4.045-1.928-4.95-1.85-.905-3.87-.094-5.091 1.517-1.464 1.931-5.405 6.991-5.405 6.991A6.093 6.093 0 0 0 .62 16.592a6.03 6.03 0 0 0-.288 4.635 6.03 6.03 0 0 0 3.073 3.482c.839.41 1.735.618 2.663.618a6.031 6.031 0 0 0 5.956-4.925l3.095 1.374c.561.25 1.202.25 1.763 0l3.094-1.374a6.032 6.032 0 0 0 5.956 4.924c.928 0 1.824-.207 2.663-.617a6.03 6.03 0 0 0 3.073-3.482 6.026 6.026 0 0 0-.289-4.635zM9.55 20.959a3.852 3.852 0 0 1-3.483 2.174 3.832 3.832 0 0 1-1.699-.396 3.85 3.85 0 0 1-1.962-2.223 3.85 3.85 0 0 1 .184-2.958 3.852 3.852 0 0 1 3.484-2.173A3.878 3.878 0 0 1 9.55 20.96zM16 19.014a1.509 1.509 0 1 1 0-3.018 1.509 1.509 0 0 1 0 3.018zm13.592 1.5a3.848 3.848 0 0 1-1.961 2.223 3.83 3.83 0 0 1-1.698.396 3.852 3.852 0 0 1-3.484-2.174 3.877 3.877 0 0 1 3.476-5.576c1.493 0 2.827.833 3.483 2.173.455.93.52 1.98.184 2.958z"
                          fill="#fff"
                          fillRule="nonzero"
                        />
                      </svg>
                    </i>{' '}
                    {insight.type}
                  </div>
                </div>
              </a>
            ))}
          </div>

          <div className="perfect-trek-container-mobile d-md-none">
            <Slider {...settings}>
              {Insights.map((insight, idx) => (
                <div className="block-grid" key={insight.name}>
                  <a
                    href={insight.link}
                    className="block"
                    data-toggle="modal"
                    data-target=".insights-modal"
                    key={insight.name}
                  >
                    <div className={`block-background block-background--${idx + 1}`} />
                    <div className="block-content">
                      <div>
                        <strong>{insight.name}</strong>
                      </div>
                      <div>
                        <i className={insight.icon}>
                          <svg viewBox="0 2 32 32" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M31.38 16.592a6.068 6.068 0 0 0-1.254-1.704s-4.094-5.21-5.404-6.991c-1.197-1.63-3.242-2.422-5.093-1.517-1.85.905-2.655 3.064-1.928 4.95l.577 2.244h-4.556l.576-2.244c.728-1.886-.077-4.045-1.928-4.95-1.85-.905-3.87-.094-5.091 1.517-1.464 1.931-5.405 6.991-5.405 6.991A6.093 6.093 0 0 0 .62 16.592a6.03 6.03 0 0 0-.288 4.635 6.03 6.03 0 0 0 3.073 3.482c.839.41 1.735.618 2.663.618a6.031 6.031 0 0 0 5.956-4.925l3.095 1.374c.561.25 1.202.25 1.763 0l3.094-1.374a6.032 6.032 0 0 0 5.956 4.924c.928 0 1.824-.207 2.663-.617a6.03 6.03 0 0 0 3.073-3.482 6.026 6.026 0 0 0-.289-4.635zM9.55 20.959a3.852 3.852 0 0 1-3.483 2.174 3.832 3.832 0 0 1-1.699-.396 3.85 3.85 0 0 1-1.962-2.223 3.85 3.85 0 0 1 .184-2.958 3.852 3.852 0 0 1 3.484-2.173A3.878 3.878 0 0 1 9.55 20.96zM16 19.014a1.509 1.509 0 1 1 0-3.018 1.509 1.509 0 0 1 0 3.018zm13.592 1.5a3.848 3.848 0 0 1-1.961 2.223 3.83 3.83 0 0 1-1.698.396 3.852 3.852 0 0 1-3.484-2.174 3.877 3.877 0 0 1 3.476-5.576c1.493 0 2.827.833 3.483 2.173.455.93.52 1.98.184 2.958z"
                              fill="#fff"
                              fillRule="nonzero"
                            />
                          </svg>
                        </i>{' '}
                        {insight.type}
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default TravelInsights;



// WEBPACK FOOTER //
// ./src/screens/Landing/Insights.jsx